import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { StationNature } from '@/types/types'
import { computed } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'

export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18nTl('Evses')



const selected = computed({
  get() {
    return [StationNature.SN_ESS, StationNature.SN_PVES, StationNature.SN_EVSE].filter((i) => {
      console.log((Number(props.modelValue) & i) === i)
      console.log(i)
      console.log(props.modelValue)
      return (Number(props.modelValue) & Number(i)) === Number(i)
    })
  },
  set(val) {
    console.log(val)
    const combined = val.reduce((acc, curr) => Number(acc) | Number(curr), 0)
    emit('update:modelValue', Number(combined))
  },
})

const stationNatureList = [
  { value: StationNature.SN_EVSE, label: t('Evses.evseStationNatureSN_EVSE') },
  { value: StationNature.SN_ESS, label: t('Evses.evseStationNatureSN_ESS') },
  { value: StationNature.SN_PVES, label: t('Evses.evseStationNatureSN_PVES') },
]

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: _unref(selected),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
    placeholder: _ctx.$t('Operation.selectStationNature'),
    multiple: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stationNatureList, (stationNature) => {
        return _createVNode(_component_el_option, {
          key: stationNature.value,
          label: stationNature.label,
          value: stationNature.value
        }, null, 8, ["label", "value"])
      }), 64))
    ]),
    _: 1
  }, 8, ["modelValue", "placeholder"]))
}
}

})